import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { find as _find, findIndex as _findIndex } from 'lodash';

import { getNameInCurrentLanguage } from 'helpers/intl';

import FormInput from 'components/forms/FormInput';
import FormColorSelector from 'components/cms/settings/components/CmsColorSelector';

class StylesVariableFormElement extends React.Component {
  // get value from entity, without the name or style attribute data
  getValue = () => {
    const { entity, stylesVariable } = this.props;

    const entityStylesVariables = entity.getStylesVariables();
    const entityStylesVariable = _find(entityStylesVariables, o => o.variable.id === stylesVariable.id);

    if (entityStylesVariable) {
      return entityStylesVariable.getValue();
    }

    return stylesVariable.default_value;
  };

  handleChange = (name, value) => {
    // console.log(name)
    // console.log(value)
    const { entity, stylesVariable, changeEntity } = this.props;

    const entityStylesVariables = entity.getStylesVariables().slice();
    const entityStylesVariable = _find(entityStylesVariables, o => o.variable.id === stylesVariable.id);
    const index = _findIndex(entityStylesVariables, o => o.variable.id === stylesVariable.id);

    let newStylesVariable;
    if (index >= 0) {
      newStylesVariable = entity.createValue('stylesVariables', [], {
        id: entityStylesVariable.getId(),
        variable: stylesVariable,
        value,
      });
    } else {
      newStylesVariable = entity.createValue('stylesVariables', [], {
        variable: stylesVariable,
        value,
      });
    }

    if (index >= 0) {
      entityStylesVariables.splice(index, 1, newStylesVariable);
    } else {
      entityStylesVariables.push(newStylesVariable);
    }
    // console.log(entityStylesVariables);
    const newEntity = { ...entity.updateValue('stylesVariables', entityStylesVariables, []) };
    // console.log(newEntity);
    changeEntity(newEntity);
  };

  getElement = () => {
    const { appIntl, stylesVariable, disabled } = this.props;

    const label = getNameInCurrentLanguage(stylesVariable.name, appIntl);

    switch (stylesVariable.type) {
      // "size"

      case 'margin':
      case 'padding':
      case 'percent':
      case 'fontFamily':
      case 'fontSize': {
        return (
          <FormInput
            onChange={this.handleChange}
            name={stylesVariable.id}
            value={this.getValue()}
            label={label}
            disabled={disabled}
          />
        );
      }

      case 'color': {
        return (
          <FormColorSelector
            setParam={this.handleChange}
            label={label}
            getParamValue={() => this.getValue()}
            disableAlpha={false}
            resetColor={stylesVariable.default_value}
            disabled={disabled}
          />
        );
      }

      case 'scale': {
        return (
          <FormInput
            type="number"
            step="0.01"
            onChange={this.handleChange}
            name={stylesVariable.id}
            value={this.getValue()}
            label={label}
            disabled={disabled}
          />
        );
      }

      default: {
        return null;
      }
    }
  };

  render() {
    const { stylesVariable } = this.props;

    return stylesVariable ? this.getElement() : null;
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default injectIntl(connect(mapStateToProps)(StylesVariableFormElement));
